<template>
  <div class="instagram-feed">
    <!-- <div class="newsmaker-container">
      <thumbnail v-for="(post, i) in newsMakerPosts" :key="i" :post="post" @click="currentPost = post"></thumbnail>
    </div> -->
    <div class="normal-post-container">
      <!-- <p v-html="attributes.value.readertitle"></p> -->
      <!-- <thumbnail v-for="(post, i) in normalPosts" :key="i" :post="post" @click="currentPost = post"></thumbnail> -->
      <thumbnail v-for="(post, i) in orderedPosts" :key="i" :post="post" @click="currentPost = post"></thumbnail>
    </div>
    <div class="view-more"><a :href="attributes.value.viewmorelink" v-html="attributes.value.viewmorebuttontext" @click="onViewMoreClick"></a></div>
    <transition name="fadepopup">
      <pop-up v-if="currentPost" @close="currentPost = null">
        <component :post="currentPost" :is="currentPost.postType"></component>
        <div class="text-content">
          <div class="user">
            <img v-if="currentPost.profilePic" :src="currentPost.profilePic"/>
            <div class="detail">
              <span v-html="currentPost.name"></span>
              <span v-if="currentPost.designation" v-html="currentPost.designation"></span>
            </div>
          </div>
          <div class="text">
            <strong v-if="currentPost.subName">{{currentPost.subName}}</strong>
            <span v-for="(caption, i) in currentPost.captions" :key="i" v-html="caption"></span>
          </div>
        </div>
      </pop-up>
    </transition>
  </div>
</template>

<script>
import * as InstaComponents from './components/index'
import Thumbnail from './Thumbnail.vue'
import PopUp from './PopUp.vue'

const JSON_ENDPOINT = process.env.NODE_ENV === 'production'
  ? 'https://www.straitstimes.com/multimedia/graphics/json/'
  : 'https://st-graphics-dev-json.s3-ap-southeast-1.amazonaws.com/'

export default {
  props: ['attributes'],
  components: {...InstaComponents, Thumbnail, PopUp},
  data () {
    const {mode, normals, hashtag} = this.attributes.value
    return {
      newsMakerDetailRef: {},
      currentPost: null,
      hashtag: hashtag,
      posts: null,
      // newsmakers: newsmakers || [],
      normals: normals || [],
      mode: mode || 'auto'
    }
  },
  computed: {
    orderedPosts () {
      // const sortKey = 'timeStamp'
      if (!this.posts) return []
      return Object.keys(this.posts)
        .map(key => this.posts[key])
        // .filter(post => post) // filter out post that is set to null
        // .sort((a, b) => b[sortKey] - a[sortKey])
        // .sort((a, b) => a[sortKey] - b[sortKey])
    }
    // newsMakerPosts () {
    //   return this.orderedPosts.filter(post => post.isNewsMaker)
    // },
    // normalPosts () {
    //   return this.orderedPosts.filter(post => !post.isNewsMaker)
    // }
  },
  methods: {
    onViewMoreClick () {
      this.$analytics.getClient('first-meal-instagram-feed-2020').track('click', 'btn-view-more')
    },
    getPostType (type, isVideo) {
      if (type === 'GraphSidecar') return 'InstaGallery'
      if (type !== 'GraphSidecar' && isVideo) return 'InstaVideo'
      if (type !== 'GraphSidecar' && !isVideo) return 'InstaPhoto'
    },
    fetchPosts () {
      // const newsMakerShortCodeRef = this.newsmakers.reduce((acc, postId) => {
      //   acc[postId] = true
      //   return acc
      // }, {})

      const allPostRequests = this.normals
      // const allPostRequests = [...this.newsmakers, ...this.normals]
        .map(postId => fetch(`https://www.instagram.com/p/${postId}/?__a=1`, {method: 'GET', cache: 'force-cache'})
        .then(res => res.json()).catch(err => {
          console.log('fail to fetch ', postId)
          throw err
        }))

      return Promise.all(allPostRequests)
      .then(rawPosts => {
        const newPosts = {}
        rawPosts
        .map(item => item.graphql.shortcode_media)
        .filter(p => !p.is_ad) // filter ad post
        .forEach(p => {
          const {
            owner: {username, full_name, profile_pic_url},
            __typename,
            edge_media_to_caption,
            edge_media_to_parent_comment,
            display_resources,
            edge_sidecar_to_children,
            video_url,
            shortcode,
            is_video,
            taken_at_timestamp
          } = p
          // const nmDetail = this.newsMakerDetailRef[username]
          const nmDetail = null
          // const isNewsMaker = !!nmDetail || newsMakerShortCodeRef[shortcode]
          const isNewsMaker = false

          // if (!this.nmPostReady2020 && isNewsMaker) return

          const name = (nmDetail && nmDetail.name) || (username === 'straits_times' && full_name) || username
          const subName = nmDetail ? username : null
          const designation = (nmDetail && nmDetail.designation) || null
          const postType = this.getPostType(__typename, is_video)

          const captions = (edge_media_to_caption.edges && edge_media_to_caption.edges.map(o => o.node.text)) || []
          const additionalCaptions = edge_media_to_parent_comment.edges
            .filter(o => o.node.text.toLowerCase().indexOf(this.hashtag) !== -1)
            .map(o => o.node.text)
          if (additionalCaptions.length > 0) captions.push(...additionalCaptions)

          const profilePic = profile_pic_url
          const previewPic = display_resources[0].src
          const gallerySrc = edge_sidecar_to_children && edge_sidecar_to_children.edges.map(o => o.node.display_resources[0].src)
          const videoSrc = video_url || null
          const timeStamp = taken_at_timestamp
          newPosts[shortcode] = {
            isNewsMaker, username, name, subName, designation, postType, captions, profilePic, previewPic, gallerySrc, videoSrc, shortcode, timeStamp
          }
        })
        return newPosts
      })
    },
    fetchPostManual () {
      return fetch(JSON_ENDPOINT + this.attributes.value.manualposts)
        .then(res => res.json())
        .then(data => {
          const newPosts = {}
          data
          .filter(d => d.username && !d.hide)
          .filter(d => !d.year || (parseInt(d.year) === 2019 && !this.nmPostReady2020))
          .forEach(d => {
            const {username, postType, captionStr, profilePic, previewPic, gallerySrcStr, videoSrc, shortcode, timeStamp} = d
            // const nmDetail = this.newsMakerDetailRef[username]
            const nmDetail = null
            // const isNewsMaker = !!nmDetail
            const isNewsMaker = false
            const name = (nmDetail && nmDetail.name) || (username === 'straits_times' && 'The Straits Times') || username
            const subName = nmDetail ? username : null
            const designation = (nmDetail && nmDetail.designation) || null
            const captions = [captionStr]
            const gallerySrc = gallerySrcStr && gallerySrcStr.split(',').map(src => src.trim())
            newPosts[shortcode] = {
              isNewsMaker, username, name, subName, designation, postType, captions, profilePic, previewPic, gallerySrc, videoSrc, shortcode, timeStamp
            }
          })
          return newPosts
        })
    },
    // fetchNewsmakerDetails () {
    //   return fetch(JSON_ENDPOINT + '1DrPSuop6AEk3Ac5dxGrVn6xrx4WjafWPkv9J3Puyen4/977367900.json')
    //     .then(res => res.json())
    //     .then(data => {
    //       const nmDetailRef = {}
    //       data.forEach(d => {
    //         const name = d['Newsmaker\'s Full Name']
    //         const designation = d['Designation']
    //         const company = d['Company']
    //         const id = d['Instagram Handle'].replace('@', '').trim()
    //         nmDetailRef[id] = {name, designation, company}
    //       })
    //       return nmDetailRef
    //     })
    // }
  },
  mounted () {
    // this.fetchNewsmakerDetails()
    //   .then(nmDetailRef => {
    //     this.newsMakerDetailRef = nmDetailRef
    //     this.$loading.withLoading(() => {
    //       return Promise.all([
    //         this.fetchPosts(),
    //         this.fetchPostManual()
    //       ]).then(([posts, postManuals]) => {
    //         this.posts = {...posts, ...postManuals}
    //       })
    //     })()
    //   })
    this.$loading.withLoading(this.mode === 'auto' ? this.fetchPosts : this.fetchPostManual)().then(posts => {
      this.posts = posts
    })
  }
}
</script>
<style lang="scss" scoped>
  .instagram-feed {
    max-width: 1340px;
    margin: 0 auto;
    text-align: center;

    .newsmaker-container {
      margin-bottom: 40px;
    }

    .normal-post-container {
      margin-bottom: 40px;
      padding-top: 15px;
      // border-top: 1px dotted #868686;

      & > p {
        text-align: left;
        padding: 0 10px;
        line-height: 1.2;
      }
    }

    .view-more {
      padding-top: 30px;
      a {
        display: inline;
        outline: none;
        padding: 5px 25px;
        border: 1px solid rgba(12,43,87,.5);
        background-color: transparent;
        border-radius: 25px;
        color: #333;
        text-decoration: none;
        font-family: $font-CuratorRegular;
        text-align: center;
        font-size: 15px;
        transition: border .15s ease-out;
        &:hover {
          border: 1px solid #333;
        }
      }
    }
  }

  .pop-container {
    .text-content {
      text-align: left;
      padding: 0 3%;
      margin: 0 auto;
      max-width: 90%;
      .user {
        padding: 10px 0;

        & > * {
          display: inline-block;
          vertical-align: top;
        }

        img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          padding-right: 5px;
        }

        .detail {
          width: calc(100% - 60px);

          span {
            font-family: $font-CuratorBold;
            font-size: 16px;
            color: #333;
            // display: block;
            &:nth-child(2) {
              display: block;
              font-family: $font-CuratorRegular;
              font-size: 15px;
              color: #666666;
              clear: both;
            }
          }
        }
      }
      .text {
        font-size: 16px;
        color: #333;
        font-family: $font-CuratorRegular;
        word-break: break-word;

        span {
          display: inline-block;
        }
      }
    }
  }

.fadepopup-enter-active {
  transition: opacity 0.5s;
}

.fadepopup-enter,
.fadepopup-leave-to {
  opacity: 0;
}
</style>
